import { cn } from '@/lib/utils';
import {
  NO_REORDER_POINT,
  STOCK_STATUSES,
  STOCK_STATUS_LABELS,
  type StockStatus,
} from '@/features/inventory/stockStatus';

// Same hues as StockStatusBadge.
const STATUS_DOT_CLASSES: Record<StockStatus, string> = {
  out: 'bg-red-600',
  low: 'bg-orange-500',
  in_transit: 'bg-yellow-300',
  in_stock: 'bg-green-500',
  overstock: 'bg-orange-200 ring-1 ring-inset ring-orange-400',
};

/** Options for a "Stock status" faceted filter over `stockStatusFilterValue`. */
export const STOCK_STATUS_FILTER_OPTIONS = [
  ...STOCK_STATUSES.map((status) => ({
    value: status as string,
    label: STOCK_STATUS_LABELS[status],
    icon: <span className={cn('h-2 w-2 shrink-0 rounded-full', STATUS_DOT_CLASSES[status])} />,
  })),
  {
    value: NO_REORDER_POINT,
    label: 'No reorder point',
    icon: <span className="h-2 w-2 shrink-0 rounded-full border border-muted-foreground" />,
  },
];
